import { render } from "./BtnUp.vue?vue&type=template&id=86d0c694"
import script from "./BtnUp.vue?vue&type=script&lang=js"
export * from "./BtnUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__